import { BoxProps, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { useState } from 'react'
import { Switch } from 'react-native'
import { ExpandAddView } from '../../components/ExpandAddView'
import { useStores } from '../../data/store'
import { ApprovalTypes } from '../../utils/constants'
import { MasterApprovals } from '../EntityApprovals/MasterApprovals'
import { EssAuditTrials } from '../EssAuditTrials'

const FeePackageApprovals = () => {
  const { packageFileUploadApproval, hasAuditAccess, isAccessConfigPriviledged } = useStores((store) => ({
    packageFileUploadApproval: store.user.getAccessConfig(['mdr', 'package_file_upload', 'approve', 'isAccessible']),
    hasAuditAccess: store.user.getAccessConfig(['sys_control_config', 'audit', 'approval_audit_fetch', 'isAccessible']),
    isAccessConfigPriviledged: store.user.getAccessConfig([
      'sys_control_config',
      'audit',
      'approval_audit_privileged',
      'isAccessible',
    ]),
  }))

  const [isUserApprover, setUserApprover] = useState(false)

  const handleToggle = (val: boolean) => {
    setUserApprover(val)
  }

  return (
    <ModBox>
      <ModBox {...styles.container} show={packageFileUploadApproval}>
        <ExpandAddView title={'Package Approvals'}>
          <MasterApprovals type={ApprovalTypes.FEE_PACKAGE_FILE_UPLOAD} />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox
        show={!isAccessConfigPriviledged && hasAuditAccess}
        p={40}
        align={'center'}
        justify={'flex-end'}
        flexDirection={'row'}>
        <TextNew title={'User'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
        <SpacerNew direction={'horizontal'} size={12} />
        <Switch onValueChange={handleToggle} value={isUserApprover} />
        <SpacerNew direction={'horizontal'} size={12} />
        <TextNew title={'Approver'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox {...styles.container} show={hasAuditAccess}>
        <ExpandAddView title={'Audit Trails'}>
          <EssAuditTrials type={ApprovalTypes.MDR_PACKAGE_FILE_UPLOAD_AUD_TRIAL} isApprover={isUserApprover} />
        </ExpandAddView>
      </ModBox>
    </ModBox>
  )
}

export default FeePackageApprovals

const styles = {
  container: {
    backgroundColor: 'WHITE',
  } as BoxProps,
  subcontainer: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
  } as BoxProps,
}
